import { FC, ReactNode, Suspense, useMemo } from "react";
import { ProSpin } from '../antd';
import KeepAlive from "react-activation";
import { RouteObject, useRoutes } from "react-router-dom";
import { IRouter } from "../constants/interface";

interface RoutersProps {
  /** 路由配置 */
  items: IRouter[];
  /** 是否缓存 */
  isCache?: boolean;
}

export const loadingNode: ReactNode = (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  }}>
    <ProSpin spinning />
  </div>
);

export const syncRoute = (routeConfig: IRouter[], isCache: boolean, parentPath?: string): RouteObject[] => {
  const mRouteTree: RouteObject[] = [];
  routeConfig.forEach(route => {
    mRouteTree.push({
      path: route.path,
      element: route.component ? (
        isCache ? (
          route.children ? (
            <Suspense fallback={loadingNode}>
              <route.component />
            </Suspense>
          ) : (
            <KeepAlive
              cacheKey={parentPath ? `${parentPath === '/' ? '' : parentPath}/${route.path}` : route.path}
              name={parentPath ? `${parentPath === '/' ? '' : parentPath}/${route.path}` : route.path}
              autoFreeze={false}
            >
              <Suspense fallback={loadingNode}>
                <route.component />
              </Suspense>
            </KeepAlive>
          )
        ) : (
          <Suspense fallback={loadingNode}>
            <route.component />
          </Suspense>
        )
      ) : undefined,
      children: route.children && syncRoute(route.children, isCache, parentPath ? `${parentPath === '/' ? '' : parentPath}/${route.path}` : route.path),
    });
  });
  return mRouteTree;
};

/** 根据配置生成路由 */
const Routers: FC<RoutersProps> = (props) => {
  const { items, isCache = true, } = props;
  const routeTree: RouteObject[] = useMemo(() => {
    const newRouteTree: RouteObject[] = syncRoute(items, isCache);
    return newRouteTree;
  }, [items]);
  return useRoutes(routeTree);
};

export default Routers;
